<div id="generate-questions-moodle-container">

    <h1>Generar preguntas para Moodle</h1>

    <div id="units-lessons-select" class="mb-3">
        <div *ngFor="let unit of units">
            <label for="">
                <input class="me-2" type="checkbox" [value]="unit.id" [(ngModel)]="unit.checked" (ngModelChange)="check(unit)">
                <span>{{ unit.name }}</span>

                <div class="ms-3" *ngFor="let lesson of unit.lessons">
                    <input class="me-2" type="checkbox" [value]="lesson.id" [(ngModel)]="lesson.checked" (ngModelChange)="check(lesson)">
                    <span>{{ lesson.name }}</span>
                </div>
            </label>
        </div>
    </div>

    <div id="buttons" class="mb-3">
        <button class="btn btn-primary me-3" (click)="generateQuestions($event)">
            <i class="fas fa-question"></i>
            <span>Generar</span>
        </button>
        <button class="btn btn-primary me-3" (click)="showQuestions = !showQuestions" *ngIf="unitQuestions.length > 0">
            <div *ngIf="showQuestions">
                <i class="fas fa-eye-slash"></i>
                <span>Ocultar preguntas</span>
            </div>
            <div *ngIf="!showQuestions">
                <i class="fas fa-eye"></i>
                <span>Mostrar preguntas</span>
            </div>
        </button>
        <button class="btn btn-primary me-3" (click)="exportQuestionsJSON()" *ngIf="unitQuestions.length > 0">
            <i class="fas fa-file-download"></i>
            <span>Exportar a JSON</span>
        </button>
    </div>

    <div id="status">
        <div id="loading" *ngIf="state == 'loading'">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Generando preguntas, espere por favor...</span>
        </div>
        <div id="success" class="text-success" *ngIf="state == 'success'">
            <i class="fas fa-check"></i>
            <span>¡Preguntas generadas correctamente!</span>
        </div>
        <div id="error" class="text-danger" *ngIf="state == 'error'">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Error</span>
        </div>
    </div>

    <div id="units-questions" *ngIf="showQuestions">
        <div *ngFor="let unit of unitQuestions">
            <p>Preguntas para la {{ unit.name }}</p>
            <div *ngFor="let question of unit.questions">
                <div>{{ question.sentence }}</div>
                <ul *ngFor="let option of question.options">
                    <li>{{ option }}</li>
                </ul>
                <div>{{ question.solution }}</div>
            </div>
        </div>
    </div>

</div>